/**
 * Mit dem Counter-Editor-Stil belegte zahlen hochzählen lassen.
 *
 * Das Counterup script lässt im Counter-Editor-Stil belegte zahlen hochzählen.
 * Getriggert wird im Vieport. Dazu greift das script auf die Library Waypoint.js zu.
 * @see BASIC__library__waypoint
 *
 * @param {string} selector - jQuery Selector für den die zahlen, die hochgezählt werden
 * Events: document.ready
 *
 * @see https://github.com/ciromattia/jquery.counterup
 **/

function nc_initCounterup(selector) {
    var moduleLogger = LoggerManager.get('counterup').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        moduleLogger.info('Starting Script');
        $(selector).counterUp({
            delay: 20,
            time: 4000,
            beginAt: 0,
        });
    });
    moduleLogger.info('INIT ENDE');
}